import React, { useState } from "react"

const { Container , Row , Col  , Card , CardBody, Button

} = require("reactstrap")
import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTags from "react-meta-tags"
import { useQuery, useMutation, useQueryClient } from "react-query"
import { getEvents, getParentingSpaceUserList, removeSpaceMember, getUserById, getUserSubscriptionById } from "helpers/fakebackend_helper"
import UserDetailsModal from "../../components/Common/UserDetailsModal"
import SubscriptionStatusBadge from "../../components/Common/SubscriptionStatusBadge"
import SubscriptionManagement from "../../components/Common/SubscriptionManagement"


const SpaceMemberList = () => {

    const queryClient = useQueryClient();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
 
    const { data, isLoading } = useQuery('space_user_list', getParentingSpaceUserList, {
        // staleTime: 120000,
          refetchOnWindowFocus: false,
        });

    // Query for user details
    const { data: userDetails, isLoading: isUserDetailsLoading } = useQuery(
        ['user_details', selectedUserId],
        () => getUserById(selectedUserId),
        {
            enabled: !!selectedUserId,
            refetchOnWindowFocus: false,
        }
    );

    // Query for user subscription status
    const { data: userSubscription, isLoading: isSubscriptionLoading } = useQuery(
        ['user_subscription', selectedUserId],
        () => getUserSubscriptionById(selectedUserId),
        {
            enabled: !!selectedUserId,
            refetchOnWindowFocus: false,
        }
    );

    const removeMemberMutation = useMutation(removeSpaceMember, {
        onSuccess: () => {
            // Refetch the user list after successful removal
            queryClient.invalidateQueries('space_user_list');
        },
        onError: (error) => {
            console.error('Error removing member:', error);
            // You can add toast notification here if needed
        }
    });

    const handleRemoveMember = (memberId) => {
        if (window.confirm('Are you sure you want to remove this member from the space?')) {
            removeMemberMutation.mutate(memberId);
        }
    };

    const handleViewUserDetails = (userId) => {
        setSelectedUserId(userId);
        setIsModalOpen(true);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
        if (isModalOpen) {
            setSelectedUserId(null);
        }
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags></MetaTags>
                <Container fluid>
                    <Breadcrumbs title="Members" breadcrumbItem="Members" />

                    <Row>
                        <Col >
                            <Card>
                                <CardBody>
                                    {isLoading ? (
                                        <div>Loading...</div>
                                    ) : !data?.users ? (
                                        <div>No users available.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-nowrap align-middle mb-0">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">ID</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Email</th>
                                                        <th scope="col">Role</th>
                                                        <th scope="col">Subscription Status</th>
                                                        <th scope="col">Subscription Management</th>
                                                        <th scope="col">Created At</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {data.users.map(user => (
                                                        <tr key={user.id}>
                                                            <td>{user.id}</td>
                                                            <td>{user.name}</td>
                                                            <td>{user.email}</td>
                                                            <td>{user?.pivot?.role}</td>
                                                            <td>
                                                                <SubscriptionStatusBadge userId={user.id} />
                                                            </td>
                                                            <td>
                                                                <SubscriptionManagement userId={user.id} userName={user.name} />
                                                            </td>
                                                            <td>{new Date(user.pivot.created_at).toLocaleString()}</td>
                                                            <td>
                                                                <div className="d-flex gap-2">
                                                                    <Button
                                                                        color="info"
                                                                        size="sm"
                                                                        onClick={() => handleViewUserDetails(user.id)}
                                                                    >
                                                                        View Details
                                                                    </Button>
                                                                    <Button
                                                                        color="danger"
                                                                        size="sm"
                                                                        onClick={() => handleRemoveMember(user.id)}
                                                                        disabled={removeMemberMutation.isLoading}
                                                                    >
                                                                        {removeMemberMutation.isLoading ? 'Removing...' : 'Remove'}
                                                                    </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            {/* User Details Modal */}
            <UserDetailsModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                userData={userDetails}
                isLoading={isUserDetailsLoading}
            />
        </React.Fragment>
    )
}

export default SpaceMemberList
